export enum UrlParams {
  INVITATION_TOKEN = 'invitationToken',
  ACTIVE_TEAM = 'activeTeam',
  TEAM_ROLE_FILTER = 'roleFilter',
  EMAIL = 'email',
  TOKEN = 'token',
  INVITING_PERSON = 'invitingPerson',
  INVITING_CLUB = 'invitingClub',
}
